// move product with specified token to front of array if possible
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
export var moveProductToFrontOfArray = function(products, highlightToken, trackWhetherProductWasHighlighted) {
    if (!highlightToken || typeof highlightToken !== "string" || !products.some(function(item) {
        return item !== undefined;
    })) {
        // no valid token or no products yet, product was not intended to be highlighted so don't track
        return products;
    }
    var highlightedProductIndex = products.findIndex(function(item) {
        var _item_product;
        return (item === null || item === void 0 ? void 0 : (_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product.token) === highlightToken;
    });
    // product not in list, track failure
    if (highlightedProductIndex === -1) {
        trackWhetherProductWasHighlighted === null || trackWhetherProductWasHighlighted === void 0 ? void 0 : trackWhetherProductWasHighlighted("false");
        return products;
    }
    // All highlight failures have escaped, track success
    trackWhetherProductWasHighlighted === null || trackWhetherProductWasHighlighted === void 0 ? void 0 : trackWhetherProductWasHighlighted("true");
    // product is already in front
    if (highlightedProductIndex === 0) {
        return products;
    }
    var productsWithHighlights = products.slice();
    var _productsWithHighlights_splice = _sliced_to_array(productsWithHighlights.splice(highlightedProductIndex, 1), 1), productToHighlight = _productsWithHighlights_splice[0];
    productsWithHighlights.unshift(productToHighlight);
    return productsWithHighlights;
};
